import useTranslation from '../../utils/useTranslation';
import Reveal from '../Reveal';

const ICONS = {
  address: (
    <>
      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z" />
      <circle cx="12" cy="10" r="3" />
    </>
  ),
  phone: (
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
  ),
  email: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3 7 9 6 9-6" />
    </>
  ),
};

function ContactIcon({ name, className, bold = false }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={bold ? '2.25' : '2'}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {ICONS[name]}
    </svg>
  );
}

export default function ContactSection({ innerRef }) {
  const { t } = useTranslation();

  const cards = [
    {
      key: 'address',
      label: t('contact_address_label'),
      desc: t('contact_address_desc'),
      value: t('contact_address_value'),
      href: null,
    },
    {
      key: 'phone',
      label: t('contact_phone_label'),
      desc: t('contact_phone_desc'),
      value: t('contact_phone_value'),
      href: `tel:${t('contact_phone_value').replace(/[\s-]/g, '')}`,
    },
    {
      key: 'email',
      label: t('contact_email_label'),
      desc: t('contact_email_desc'),
      value: t('contact_email_value'),
      href: `mailto:${t('contact_email_value')}`,
    },
  ];

  return (
    <section className="section alt" id="contact" ref={innerRef}>
      <div className="container">
        <h2 className="partners-title">
          <span className="partners-title-line" aria-hidden="true" />
          <span className="partners-title-text">{t('contact_title')}</span>
          <span className="partners-title-line" aria-hidden="true" />
        </h2>

        <div className="contact-grid">
          {cards.map((c, i) => (
            <Reveal
              as="article"
              key={c.key}
              className={`contact-card contact-card--${c.key}`}
              delay={i * 80}
            >
              <span className="contact-icon" aria-hidden="true">
                <ContactIcon name={c.key} bold />
              </span>
              <h3 className="contact-label">{c.label}</h3>
              <span className="contact-sep" aria-hidden="true" />
              <p className="contact-desc">{c.desc}</p>
              {c.href ? (
                <a
                  className="contact-info is-link"
                  href={c.href}
                  dir={c.key === 'phone' ? 'ltr' : undefined}
                >
                  <ContactIcon name={c.key} className="contact-info-icon" />
                  <span>{c.value}</span>
                </a>
              ) : (
                <div className="contact-info">
                  <ContactIcon name={c.key} className="contact-info-icon" />
                  <span>{c.value}</span>
                </div>
              )}
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
